import React, { useEffect, useState } from "react";
import { Calendar } from "primereact/calendar";
import ReactModal from "react-modal";
import { connect } from "react-redux";
import moment from "moment";
import {
  CalendarEventModel,
  GoogleCalendarEventModel,
  ICalenderEvents,
} from "../../models/common/ICalendar";
import {
  getCalenderEventsDetails,
  getGoogleCalenderEventsDetails,
} from "../../action/common/calendarActionCreator";
import { UserRole } from "../../constants/RoleEnum";
import { apiConfig } from "../../constants/apiConfig";
import { suiteType } from "../../constants/commonConstants";

const MonthCalendar = (props: ICalenderEvents) => {
  const {
    getCalenderEvents,
    getGoogleCalenderEvents,
    events,
    googleEvents,
    email,
    role,
  } = props;

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showEvent, setShowEvent] = useState(false);
  const [dateEvents, setDateEvents] = useState<CalendarEventModel[]>([]);
  const [dateGoogleEvents, setGoogleDateEvents] = useState<
    GoogleCalendarEventModel[]
  >([]);
  const [suite] = useState<suiteType>(apiConfig.suite as suiteType);


  const convertedDateTime = (date: any) => {
    const reversedDate = moment.utc(date).local().format("hh:mm A");
    return reversedDate;
  };

  const fetchCalendarEvents = () => {
    if (email) {
      const firstDayOfMonth = moment(selectedDate)
        .startOf("month")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
      const lastDayOfMonth = moment(selectedDate)
        .endOf("month")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");

      if (suite == suiteType.google) {
        getGoogleCalenderEvents(firstDayOfMonth, lastDayOfMonth, email);
      } else {
        getCalenderEvents(firstDayOfMonth, lastDayOfMonth, email);
      }
    }
  };

  useEffect(() => {
    fetchCalendarEvents();
  }, [selectedDate, email, role, getCalenderEvents, getGoogleCalenderEvents]);

  const handleDateClick = (selected: Date) => {
    suite == suiteType.google
      ? (() => {
          const formattedDate = moment(selected).format("YYYY-MM-DD");
          const eventsForSelectedDate = googleEvents?.filter(
            (event) =>
              moment(event.start.dateTime).format("YYYY-MM-DD") === formattedDate
          );
          setGoogleDateEvents(eventsForSelectedDate);
        })()
      : (() => {
          const formattedDate = moment(selected).format("YYYY-MM-DD");
          const eventsForSelectedDate = events?.filter(
            (event) =>
              moment(event.start.dateTime).format("YYYY-MM-DD") === formattedDate
          );
          setDateEvents(eventsForSelectedDate);
        })();
    setShowEvent(true);
  };

  const customDateTemplate = (dateInfo: {
    day: number;
    month: number;
    year: number;
  }) => {
    const { day, month, year } = dateInfo;
    const date = new Date(year, month, day);

    const isSpecialDate =
      suite == suiteType.google
        ? googleEvents?.some(
          (event) =>
            moment(event.start.dateTime).format("YYYY-MM-DD") ===
            moment(date).format("YYYY-MM-DD")
        )
        : events?.some(
          (event) =>
            moment(event.start.dateTime).format("YYYY-MM-DD") ===
            moment(date).format("YYYY-MM-DD")
        );

    return (
      <div className={`p-highlight ${isSpecialDate ? "special-date" : ""}`}>
        {day}
      </div>
    );
  };

  return (
    <>
      <div className="card-wrap event-monthly-calendar">
        <Calendar
          inline
          value={selectedDate}
          onChange={(e) =>
            setSelectedDate(e.value instanceof Date ? e.value : new Date())
          }
          dateTemplate={customDateTemplate}
          onSelect={(e) =>
            handleDateClick(e.value instanceof Date ? e.value : new Date())
          }
        />
      </div>
      <ReactModal
        isOpen={showEvent}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        onRequestClose={() => setShowEvent(false)}
      >
        <div className="modal-header">
          <h5 className="modal-title">
            Events on {moment(selectedDate).format("MMMM DD, YYYY")}
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowEvent(false)}
          ></button>
        </div>
        <div className="modal-body">
          {!(suite == suiteType.google) ? (
            dateEvents?.length > 0 ? (
              <ul className="eventwrap">
                {dateEvents
                  .sort(
                    (a, b) =>
                      new Date(a.start.dateTime).getTime() -
                      new Date(b.start.dateTime).getTime()
                  )
                  .map((event, index) => (
                    <li key={index} className="eventcard">
                      <div className="desc">
                        <p>
                          {convertedDateTime(event.start.dateTime)} -{" "}
                          {convertedDateTime(event.end.dateTime)}
                        </p>
                        <h2>{event.subject}</h2>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: event.bodyPreview
                              .replace(/[\r\n]*_{2,}[\s\S]*/, "")
                              .trim(),
                          }}
                        />
                      </div>
                    </li>
                  ))}
              </ul>
            ) : (
              <p>No events for this day.</p>
            )
          ) : dateGoogleEvents?.length > 0 ? (
            <ul className="eventwrap">
              {dateGoogleEvents
                .sort(
                  (a, b) =>
                    new Date(a.start.dateTime).getTime() -
                    new Date(b.start.dateTime).getTime()
                )
                .map((event, index) => (
                  <li key={index} className="eventcard">
                    <div className="desc">
                      <p>
                        {convertedDateTime(event.start.dateTime)} -{" "}
                        {convertedDateTime(event.end.dateTime)}
                      </p>
                      <h2
                        dangerouslySetInnerHTML={{
                          __html: event.summary,
                        }}
                      />
                      <p
                        dangerouslySetInnerHTML={{ __html: event.description }}
                      />
                    </div>
                  </li>
                ))}
            </ul>
          ) : (
            <p>No events for this day.</p>
          )}
        </div>
      </ReactModal>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  events: state.calendar.calenderEvents,
  email: state.userDetails.userProfileData?.email,
  googleEvents: state.calendar.googleCalenderEvents,
  role: state.userDetails.userProfileData?.currentRole,
});

const mapDispatchToProps = {
  getCalenderEvents: (
    startDateTime: string,
    endDateTime: string,
    userEmail: string
  ) => getCalenderEventsDetails(startDateTime, endDateTime, userEmail),
  getGoogleCalenderEvents: (
    startDateTime: string,
    endDateTime: string,
    userEmail: string
  ) => getGoogleCalenderEventsDetails(startDateTime, endDateTime, userEmail),
};

export default connect(mapStateToProps, mapDispatchToProps)(MonthCalendar);
